var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonetizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "monetization_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2481_6603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2481_6603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "monetization_on_2",
    d: "M11.4846 18.6154H12.4654V17.4423C13.1833 17.3821 13.8712 17.1244 14.5288 16.6692C15.1865 16.2141 15.5154 15.5077 15.5154 14.55C15.5154 13.85 15.3026 13.2532 14.8769 12.7596C14.4513 12.266 13.6385 11.8026 12.4385 11.3692C11.3359 10.9846 10.6314 10.6545 10.325 10.3788C10.0186 10.1032 9.86538 9.71025 9.86538 9.2C9.86538 8.68975 10.0644 8.26475 10.4625 7.925C10.8606 7.58525 11.3898 7.41537 12.05 7.41537C12.5577 7.41537 12.9808 7.53173 13.3192 7.76443C13.6577 7.99713 13.9321 8.29232 14.1423 8.65L15.0115 8.3077C14.7769 7.82693 14.433 7.42437 13.9798 7.1C13.5266 6.77563 13.0385 6.59487 12.5154 6.5577V5.38463H11.5346V6.5577C10.6628 6.70257 10.0032 7.02757 9.55577 7.5327C9.10834 8.03782 8.88463 8.59358 8.88463 9.2C8.88463 9.91923 9.11058 10.4949 9.5625 10.9269C10.0144 11.359 10.7769 11.7692 11.85 12.1577C12.9256 12.5539 13.6484 12.9115 14.0183 13.2308C14.3881 13.55 14.5731 13.9897 14.5731 14.55C14.5731 15.2538 14.3163 15.7606 13.8029 16.0702C13.2894 16.3798 12.7385 16.5346 12.15 16.5346C11.5744 16.5346 11.0548 16.367 10.5914 16.0317C10.1279 15.6965 9.75769 15.2192 9.48077 14.6L8.6 14.9808C8.88462 15.6654 9.26635 16.199 9.7452 16.5817C10.224 16.9644 10.8038 17.2346 11.4846 17.3923V18.6154ZM12 21C10.7577 21 9.58909 20.7631 8.49423 20.2894C7.39936 19.8157 6.44679 19.1737 5.63652 18.3635C4.82627 17.5532 4.18429 16.6006 3.71058 15.5058C3.23686 14.4109 3 13.2423 3 12C3 10.7577 3.23686 9.58909 3.71058 8.49422C4.18429 7.39936 4.82627 6.44679 5.63652 5.63652C6.44679 4.82627 7.39936 4.18429 8.49423 3.71057C9.58909 3.23686 10.7577 3 12 3C13.2423 3 14.4109 3.23686 15.5058 3.71057C16.6006 4.18429 17.5532 4.82627 18.3635 5.63652C19.1737 6.44679 19.8157 7.39936 20.2894 8.49422C20.7631 9.58909 21 10.7577 21 12C21 13.2423 20.7631 14.4109 20.2894 15.5058C19.8157 16.6006 19.1737 17.5532 18.3635 18.3635C17.5532 19.1737 16.6006 19.8157 15.5058 20.2894C14.4109 20.7631 13.2423 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationIcon);
export default __webpack_public_path__ + "static/media/monetization-icon.47c9cc31f96599a555469ae5064a2318.svg";
export { ForwardRef as ReactComponent };